/* eslint-disable */
var daoBaseConfig = {
	env: 'online',
	develop: {
		xcBasePath: "https://www.cxc555.com/xcWeb/",
		domain: '192.168.1.4',
		protocol: 'http://'
	},
	test: {
		xcBasePath: "/xcWeb/",
		domain: 'test.com',
		protocol: 'http://'
	},
	online: {
		xcBasePath: "/xcWeb/",
		domain: 'cxc555.com',
		protocol: 'https://'
	},
	getBasePath:function(){
		if(daoBaseConfig.env == 'develop'){
			return daoBaseConfig.develop
		}
		if(daoBaseConfig.env == 'test'){
			return daoBaseConfig.test
		}
		if(daoBaseConfig.env == 'online'){
			return daoBaseConfig.online
		}
	}
}
export default daoBaseConfig


// WEBPACK FOOTER //
// ./src/daoBaseConfig.js